<template>
  <div class="play-bar" v-if="showPlayer" @click="handlePlayDetail">
    <div class="play-icon" @click.stop="handlePlayer">
      <img src="../assets/pause-yellow.svg" v-if="playing" class="pause">
      <img src="../assets/play-yellow.svg" v-else class="play">
    </div>
    <div class="play-title">正在播放{{ player.name }}</div>
    <div class="close-btn" @click.stop="stopPlayer">
      <img src="../assets/close-s.svg" />
    </div>
    <audio :src="player.audio_url" ref="audio" style="display: none"></audio>
  </div>
</template>

<script>
export default {
  data () {
    return {
      playing: false,
      showPlayer: false
    }
  },
  props: {
    player: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    show () {
      this.showPlayer = true
      this.playing = true
      this.$nextTick(() => {
        this.$refs.audio.play()
      })
    },
    hide () {
      this.showPlayer = false
    },
    handlePlayer () {
      if (this.playing) { // 正在播放暂停
        this.$refs.audio.pause()
      } else { // 暂停，开始播放
        this.$refs.audio.play()
      }
      this.playing = !this.playing
    },
    stopPlayer () {
      this.playing = false
      this.$refs.audio.pause()
      this.showPlayer = false
    },
    // 点击跳转景点音频播放页面
    handlePlayDetail () {
      const currentTime = this.$refs.audio.currentTime
      console.log(currentTime, '播放时间')
      window.wx.miniProgram.navigateTo({
        url: `/packageScenic/pages/subSiteDetail/index?id=${this.player.siteId}&time=${currentTime}`
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.play-bar {
  width: calc(100% - 24px);
  height: 32px;
  background-color: rgba(248, 169, 9, 0.7);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  position: absolute;
  top: 60px;
  left: 12px;
  border-radius: 16px;

  .play-icon {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background-color: #ffffff;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2);
    position: absolute;
    top: -3px;
    left: -1px;
    display: flex;
    align-items: center;
    justify-content: center;

    .pause {
      width: 20px;
    }

    .play {
      width: 15px;
      margin-left: 2px;
    }
  }

  .play-title {
    font-size: 12px;
    line-height: 32px;
    color: #ffffff;
    padding: 0 42px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .close-btn {
    position: absolute;
    right: 7px;
    top: 2px;
    width: 25px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      height: 25px;
      width: 25px;
    }
  }
}
</style>
